module.exports = __webpack_public_path__ + "img/icon_4_21.d2c59a08.png";